import Portfolio from "../components/Portfolio";
import ProjectSlider from "../components/ProjectSlider";
import ComputerCanvas from "../components/canvas/Computer";
import "../styles/projects.css";

const ProjectsPage = () => {
	return (
		<div className="component_wrapper">
			<Portfolio />

			{/* <div className="canvas_computer_container">
				<p>
					When
					<span>CODE and 3D</span>
					combined
				</p>
				<ComputerCanvas />
			</div> */}
		</div>
	);
};

export default ProjectsPage;
